<script>
import resources from './resources'

export default {
  name: 'menu-config',

  mixins: [resources]
}
</script>

<template lang="pug">
  li.config(v-if="!(!user.id)")
    | 
    .config-drop
      .title
        span.icon 
        h4 Configurações
      .subtitle Notificações
      .line
        .text Agendamento de Consultas
        .switch(
          @click.prevent="doToogleNotifySettings('schedule')",
          :class="{true: settings.notify.schedule, false: !settings.notify.schedule}"
          )
          .dot
      .line
        .text Cancelamento de Consultas
        .switch(
          @click.prevent="doToogleNotifySettings('cancel')",
          :class="{true: settings.notify.cancel, false: !settings.notify.cancel}"
          )
          .dot
      .line
        .text Transferência de Consultas
        .switch(
          @click.prevent="doToogleNotifySettings('transfer')",
          :class="{true: settings.notify.transfer, false: !settings.notify.transfer}"
          )
          .dot
      .divider
      .subtitle Tipo de Notificações
      .line
        .text E-mail
        .switch(
          @click.prevent="doToogleNotifySendSettings('email')",
          :class="{true: settings.notify.send.email, false: !settings.notify.send.email}"
          )
          .dot
      .line
        .text SMS
        .switch(
          @click.prevent="doToogleNotifySendSettings('sms')",
          :class="{true: settings.notify.send.sms, false: !settings.notify.send.sms}"
          )
          .dot
      .line
        .text
          | App Mobile
          small (Smartphones)
        .switch(
          @click.prevent="doToogleNotifyPushAppSettings()",
          :class="{true: settings.notify.send.push.app, false: !settings.notify.send.push.app}"
          )
          .dot
      .line
        .text
          | App Web
          small (Push Notifications)
        .switch(
          @click.prevent="doToogleNotifyPushWebSettings()",
          :class="{true: settings.notify.send.push.web, false: !settings.notify.send.push.web}"
          )
          .dot
      .divider
      button
        router-link(:to="{name: 'settings.config.index'}")
          span.icon 
          |  Configurações Avançadas
</template>



// WEBPACK FOOTER //
// src/layout/headers/menu/config/config.vue